module.exports = __webpack_public_path__ + "1faf5966da695a6b31d0c7d067c95c82.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-768.webp
// module id = 417
// module chunks = 0